export type SlashOption={name:string;description:string;type:string;required?:boolean;choices?:{name:string;value:string|number}[]};
export type SlashCommand={id:string;application_id:string;name:string;description:string;options:SlashOption[];appName?:string};

// "/name key:value other:"quoted text" positional words" -> command + raw option values.
// Named values win; remaining words fill the unnamed options in order, the last one takes the rest of the text.
export function parseSlash(draft:string,commands:SlashCommand[]):{command:SlashCommand;options:Record<string,string>}|null{
 const m=draft.trim().match(/^\/([a-z0-9_-]{1,32})(?:\s+([\s\S]*))?$/i);
 if(!m)return null;
 const command=commands.find(c=>c.name===m[1].toLowerCase());
 if(!command)return null;
 const options:Record<string,string>={},known=new Set(command.options.map(o=>o.name));
 let rest=m[2]||'';
 rest=rest.replace(/(?:^|\s)([a-z0-9_-]{1,32}):(?:"([^"]*)"|(\S+))/gi,(all,key,quoted,plain)=>{const k=key.toLowerCase();if(!known.has(k))return all;options[k]=quoted??plain;return ' ';}).trim();
 const open=command.options.filter(o=>options[o.name]===undefined);
 for(let i=0;i<open.length&&rest;i++){
  if(i===open.length-1){options[open[i].name]=rest;rest='';break;}
  const word=rest.match(/^(?:"([^"]*)"|(\S+))\s*/)!;options[open[i].name]=word[1]??word[2];rest=rest.slice(word[0].length);
 }
 return {command,options};
}
